/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { PianoModal } from './customBlocks/pianoModal';
import { MatrixOled128x64Modal } from './customBlocks/matrixOled128x64Modal';

Blockly.Blocks.LGO_entradas_ultrasonidO = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/091.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO);
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_RED_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('ultrasonic', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'ultrasonic',
};

Blockly.Blocks.LGO_read_dht11 = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/06.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ENTRADAS_TEMPERATURA, 'T'],
        [Blockly.Msg.LANG_ENTRADAS_HUMEDAD, 'H'],
      ]), 'TYPE');
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ENTRADAS_DHT11_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_READ_DHT11_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'dht11',
};

Blockly.Blocks.LGO_infrared = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/521.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_INFRARED)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendValueInput('COLOR')
      .appendField(Blockly.Msg.LANG_ENTRADAS_INFRARED_DETECT)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setOutput(true, 'Boolean');
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_INFRARED_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'infrared',
};

Blockly.Blocks.LGO_salidas_led_rgb = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/rgb_led.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON || 'ON', 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF || 'OFF', 'LOW'],
      ]), 'STAT');
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB_PIN_SINGLE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'ledRGB',
};

Blockly.Blocks.LGO_salidas_led_rgb_color = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/rgb_led.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB_PIN_SINGLE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_LED_RGB_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'ledRGB',
};

Blockly.Blocks.LGO_salidas_led_rgb_pwm = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/rgb_led.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('DATOINR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_RGB_COLOR);
    this.appendValueInput('DATOING')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_RGB_COLOR_G);
    this.appendValueInput('DATOINB')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_LED_RGB_COLOR_B);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB_PIN_SINGLE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_RGB_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'ledRGB',
};

Blockly.Blocks.LGO_semaphore = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/semaphore_lgo20.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR1')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_RGB)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('COLOUR2')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('COLOUR3')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SEMAPHORE_LGO20_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_LED_RGB_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'semaphore_lgo20',
};

// pinName: 'NPIN' hace que el modal lea las opciones del dropdown de pin del bloque.
Blockly.Blocks.LGO_piezo_buzzer_piano = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/piano_lgo20.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_PIANO);
    this.appendDummyInput()
      .appendField(new PianoModal({
        basePitch: 165, octave: 3, duration: 1000, pinName: 'NPIN',
      }, undefined, {}), 'PIANO');
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_LGO20_PIEZO_BUZZER_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_PIEZO_BUZZER_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'buzzer',
};

Blockly.Blocks.LGO_oled = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_OLED_DRAW);
    this.appendDummyInput()
      .appendField(new MatrixOled128x64Modal({
        frames: [{ leds: {}, duration: 1000 }],
      }, undefined, {}), 'MATRIX');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_OLED_DRAW_TOOLTIP);
  },
};

Blockly.Blocks.LGO_servo_move = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/servo_270.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE_DEGREES);
    this.appendValueInput('angulo')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_270)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_270_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};

Blockly.Blocks.LGO_servo_move_millis = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/servo_270.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MILLIS_MOVE_DEGREES);
    this.appendValueInput('angulo')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MILLIS_MOVE_MILLIS);
    this.appendValueInput('millis')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_270_MILLIS_MOVE_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_270_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};

Blockly.Blocks.LGO_servo_360 = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/servo_360.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar a la derecha', '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar a la izquierda', '4'],
        [Blockly.Msg.LANG_MOTOR_TURN_BRAKE || 'Frenar', '6'],
      ]), 'NPIN1');
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_360)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SERVO_360_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo360',
};

Blockly.Blocks.LGO_servo_360_pwm = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/servo_360.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar a la derecha', '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar a la izquierda', '4'],
        [Blockly.Msg.LANG_MOTOR_TURN_BRAKE || 'Frenar', '6'],
      ]), 'NPIN1');
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_360)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_SPEED);
    this.appendValueInput('DATOIN')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SERVO_360_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo360',
};

Blockly.Blocks.LGO_motor_doble = Blockly.Blocks.BHOOT_motor_doble;
Blockly.Blocks.LGO_motor_doble_pwm = Blockly.Blocks.BHOOT_motor_doble_pwm;
Blockly.Blocks.LGO_motor_single = Blockly.Blocks.BHOOT_motor_single;
Blockly.Blocks.LGO_motor_single_speed = Blockly.Blocks.BHOOT_motor_single_speed;
